export const DEFAULT_CAMPERS_PAGE_SIZE = 10
